define('constant',[],function () {
	'use strict';

	var _constants = {

		LOGGER: {
			DEBUG: 0,
			INFO: 1,
			WARN: 2,
			ERROR: 3
		},
		
		ARTICLE: {
			LARGE: 10,
			MEDIUM: 11,
			SMALL: 12
		},
        
        POSTER_SIZE: {
            LARGE: 1,
            MEDIUM: 2,
            SMALL: 3
        },

        CONTENT_TYPE: {
        	MOVIE: 1,
	        ARTICLE: 2,
	        SERIES: 3,
	        PLAYLIST: 4,
	        CHANNEL: 5
        },

        CONTENT_TIER: {
        	FREE_FOR_ALL: 1,
	        FREE_FOR_MEMBER: 2,
	        PREMIUM: 3,
	        SKYPLUS: 4
        },

        CHANNEL_TYPE: {
        	LIVE: 2
        },

        LIVE_STATUS: {
	      PENDING: 1,
	      ON_AIR: 2,
	      OFF_AIR: 3
	    },

	    CONTENT_STATUS: {
	    	ON_SHELF: 1
	    }
	};

	var Constants = function () {

	};

	Constants.prototype = {

		get: function (key) {

			var data = (key || '').split(':');

			if (data.length !== 2) {

				throw new TypeError('Constants#get: invalid constant [' + key + ']');
			}

			var type = data[0];
			var name = data[1];
			
			if (_.isUndefined(_constants[type][name])) {

				throw new TypeError('Constants#get: constant [' + key + '] not exist');
			}

			return _constants[type][name];
		},
	};

	return Constants;
});
